<template>
  <div style="margin-top: -3rem;">
    <md-dialog-content>
      <div class="ml-30 pt-30">
        <md-dialog-title style="margin-left: 0; font-size: 2rem;">{{options.Lang.Globale_Informationen}}</md-dialog-title>
      </div>
      <br>
      <div style="background: white; padding-top: 3rem;" class="p-20">
        <form class="md-layout" style="margin-top: -20px;">
          <div class="md-layout-item">
            <div class="p-20" style="display: flex;">
             
              <form novalidate class="formi">
                <div class="md-layout-item">
                  <div class="md-focused" style="margin-top: -6px;">
                    <label for="logo"><strong>{{options.Lang.Logo}}</strong></label>
                    <div class="uploadedLogo">
                      <img class="camera-icon" :src="logoNew" alt="">
                    </div>
                    <md-field class="fileField">
                      <md-file style="padding: 0;" class="choose-file" type="file" tabindex="4" @change="getImg"
                      name="logo" id="logo" v-model="logo" accept="image/*" />
                    </md-field>
                    </div>
                </div>

                <div class="md-layout-item">
                  <div style="padding-top: 20px;">
                    <md-button style="min-width: 155px; height: 38px; align-self: flex-start;margin: 0px 0px;"
                      tabindex="7" class="md-raised md-primary" @click="saveImg"><strong>{{options.Lang.Hochladen}}</strong>
                    </md-button>
                  </div>
                </div>
              </form>
              <br>
              <!--//////////////////-->
              <br>
              <br>
              <form novalidate class="formi">
                <div class="md-layout-item">
                  <div class="md-focused" style="margin-top: -6px;">
                    <label for="logo"><strong>{{options.Lang.LogoB}}</strong></label>
                    <div class="uploadedLogo">
                      <img class="imglogoback" :src="logoback" alt="">
                    </div>
                    <md-field class="fileField">
                      <md-file style="padding: 0;" class="choose-file" type="file" tabindex="4" @change="getImgback"
                      name="logoback" id="logoback" v-model="logobackModel" accept="image/*" />
                    </md-field>
                  </div>
                </div>

                <div class="md-layout-item">
                  <div style="padding-top: 20px;">
                    <md-button style="min-width: 155px; height: 38px; align-self: flex-start;margin: 0px 0px;"
                      tabindex="7" class="md-raised md-primary" @click="saveImgback"><strong>{{options.Lang.Hochladen}}</strong>
                    </md-button>
                  </div>
                </div>
              </form>
              <!--//////////////////-->
              <br>
              <br>
              <br>
              <form novalidate class="formi">
                <div class="md-layout-item">
                  <div class="md-focused" style="margin-top: -6px;">
                    <label for="logo"><strong>{{options.Lang.Favicon}}</strong></label>
                    <div class="uploadedLogo">
                      <img class="imglogoback" :src="logooo" alt="">
                    </div>
                    <md-field class="fileField">
                      <md-file style="padding: 0;" class="choose-file" type="file" tabindex="4" @change="getFavicon"
                      name="favicon" id="favicon" v-model="favicon" accept="image/*" />
                    </md-field>
                  </div>
                </div>

                <div class="md-layout-item">
                  <div style="padding-top: 20px;">
                    <md-button style="min-width: 155px; height: 38px; align-self: flex-start;margin: 0px 0px;"
                      tabindex="7" class="md-raised md-primary" @click="saveFavicon"><strong>{{options.Lang.Hochladen}}</strong>
                    </md-button>
                  </div>
                </div>
              </form>
  
            </div>
          </div>

        </form>
    
      </div>
     <!--////////////////////////////////////////-->
      <div style="margin-top: 3rem;">
        <md-dialog-title style="margin-left: 3rem; margin-top: 2rem; font-size: 2rem;">{{ options.Lang.AnzahlDatensätze }}</md-dialog-title>
        <br><br><br>
      <div style="background: white; padding-top: 3rem;" class="p-20">
        <form class="md-layout" style="margin-top: -20px;">
          <div class="md-layout-item">
            <div class="p-20" style="display: flex;">
                <md-field style="padding-top: 20px;" class="md-focused">
                  <label for="defaultcount"><strong>{{options.Lang.Anzahl}}</strong><span class="asterix">*</span></label>
                    <md-input tabindex="4" name="agbs" :placeholder="address.defaultcount" id="defaultcount"
                      v-model="address.defaultcount" />
                    <div style="float: right;">
                      <md-button tabindex="7" class="md-raised md-primary" @click="setDefaultCount()">{{options.Lang.Vorlagen_speichern}}
                      </md-button>
                    </div>
                </md-field>
            </div>
          </div>
        </form>
      </div>
    </div>
     <!--////////////////////////////////////////-->
  <div style="margin-top: 3rem;">
        <md-dialog-title style="margin-left: 3rem; margin-top: 2rem; font-size: 2rem;">{{ options.Lang.AuswahlNormalBrand }}</md-dialog-title>
        <br><br><br>
      <div style="background: white; padding-top: 3rem;" class="p-20">
        <form class="md-layout" style="margin-top: -20px;">
          <div class="md-layout-item">
            <div class="p-20" style="display: flex;">
             
              <md-field style="padding-top: 20px;" class="md-focused">
                <label for="defaultbrand"><strong>{{options.Lang.Branding}}</strong><span class="asterix">*</span></label>
                <md-select @md-selected="selectDefaultBrand()" v-model="defaultbrand" name="defaultbrand" id="defaultbrand">
                  <md-option v-for="(brand, index) in brands" :key="'defaultBrand' + index" :value="brand.id" >{{ brand.adresse }}</md-option>
                </md-select>
                <div style="float: right;">
                <md-button tabindex="7" class="md-raised md-primary" @click="setDefaultBrand()">{{options.Lang.Vorlagen_speichern}}
                </md-button>
              </div>
              </md-field>
              
  
            </div>
          </div>

        </form>
    
      </div>
     
    </div>
     <!--////////////////////////////////////////-->
      <div style="margin-top: 3rem;">
        <md-dialog-title style="margin-left: 3rem; margin-top: 2rem; font-size: 2rem;">
          {{ options.Lang.allgemeineSettings }}
        </md-dialog-title>
        <br><br>
        <div style="background: white; padding-top: 3rem;" class="p-20">
          <form class="md-layout" style="margin-top: -20px;">
            <div class="md-layout-item">
              <div class="p-20" style="display: flex; flex-direction: column; gap: 1rem; padding-top: 10px !important;">

                <!-- existing Storno selector (unchanged) -->
                <md-field style="padding-top: 20px;" class="md-focused">
                  <label>{{ options.Lang.SettingsStorno }}</label>
                  <md-select @input="changeStorno()" v-model="stornoStatus" name="sprache" id="sprache">
                    <md-option @input="changeStorno()" value="true"> {{ options.Lang.aktiviert }}</md-option>
                    <md-option @input="changeStorno()" value="false">{{ options.Lang.deaktiviert}}</md-option>
                  </md-select>
                </md-field>


              </div>
            </div>
          </form>
        </div>
      </div>
     <!--////////////////////////////////////////-->
  <div style="margin-top: 3rem;" v-if="options.user.supersuper == 1 || options.user.supersuper == true">
        <md-dialog-title style="margin-left: 3rem; margin-top: 2rem; font-size: 2rem;">{{ options.Lang.backPDFButton }}</md-dialog-title>
        <br><br>
        <div style="background: white; padding-top: 3rem;" class="p-20">
        <form class="md-layout" style="margin-top: -20px;">
          <div class="md-layout-item">
            <div class="p-20" style="display: flex; padding-top: 10px !important;">
             
                <md-field class="md-focused">
                  <md-button tabindex="7" class="md-raised md-primary" @click="pdfReset = true">{{options.Lang.backPDFButton}}
                      </md-button>
                 
                </md-field>

            </div>
          </div>

        </form>
    
      </div>
    </div>
     <!--////////////////////////////////////////-->
     <div id="pdfReset" v-if="pdfReset" class="md-elevation-10">
      <p>{{options.Lang.textpdfreset}}</p>
      <div class="md-layout-item">
            <div class="p-20" style="display: flex; padding-top: 10px !important; float: right;">
             
                <md-field class="md-focused">
                  <md-button tabindex="7" class="md-raised md-primary" @click="pdfReset = false">{{options.Lang.schließen}}
                      </md-button>
                 
                </md-field>

                <md-field class="md-focused">
                  <md-button tabindex="7" class="md-raised md-accent" @click="resetpdfs()">{{options.Lang.backPDF}}
                      </md-button>
                 
                </md-field>

            </div>
        </div>
      </div>

      <!-- Confirmation Modal -->


      <Error class="errorDialog" v-if="options.showError && options.user.loggedIn" :options="options"></Error>

      <Success class="errorDialog" v-if="options.showSuccess && options.user.loggedIn" :options="options"></Success>
     
    </md-dialog-content>
    
  </div>
</template>
  
<script>

import * as moment from 'moment'
import { validationMixin } from 'vuelidate'
import Success from '../../components/dialogs/Success.vue'
import {Editor, EditorContent} from '@tiptap/vue-2'
import Underline from '@tiptap/extension-underline'
import StarterKit from '@tiptap/starter-kit'
import Link from "@tiptap/extension-link";
import Error from '../../components/dialogs/Error.vue'


export default {
  name: 'formGlobalInfo',
  mixins: [validationMixin],
  components: {
    Success, EditorContent, Error
  },
  props: {
    options: {
      type: Object,
      required: true,
      
    },
  },
  data: () => ({
    brands:[],
    stornoStatus: false,
    defaultbrand: null,
    emailBetreffSupplier_de: null,
    emailBetreffSupplier_en: null,
    emailBetreffCustomer_de: null,
    emailBetreffCustomer_en: null,
    logoNew: null,
    logoback: null,
    favicon: null,
    logobackModel: null,
    showEditMail: true,
    ImageDone: false,
    editor: new Editor({
      content: '',
      extensions: [
        StarterKit,
        Underline,
        Link.configure({
          openOnClick: false,
          })
      ],
    }),
    editor2: new Editor({
      content: '',
      extensions: [
        StarterKit,
        Underline,
        Link.configure({
          openOnClick: false,
          })
      ],
    }),
    editor3: new Editor({
      content: '',
      extensions: [
        StarterKit,
        Underline,
        Link.configure({
          openOnClick: false,
          })
      ],
    }),
    editor4: new Editor({
      content: '',
      extensions: [
        StarterKit,
        Underline,
        Link.configure({
          openOnClick: false,
          })
      ],
    }),
    editor6: new Editor({
      content: '',
      extensions: [
        StarterKit,
        Underline,
        Link.configure({
          openOnClick: false,
          })
      ],
    }),
    editor7: new Editor({
      content: '',
      extensions: [
        StarterKit,
        Underline,
        Link.configure({
          openOnClick: false,
          })
      ],
    }),
    editor8: new Editor({
      content: '',
      extensions: [
        StarterKit,
        Underline,
        Link.configure({
          openOnClick: false,
          })
      ],
    }),
    editor9: new Editor({
      content: '',
      extensions: [
        StarterKit,
        Underline,
        Link.configure({
          openOnClick: false,
          })
      ],
    }),
    email: null,
    pdfReset: false,
    email2: null,
    address: {
      defaultcount: "",
      company: "",
      street: "",
      reply: "",
      agbs: "",
      replyzugang: "",
      code: "",
      city: "",
      telefon: "",
      fax: "",
      footerinfo: "",
      email: "",
      datenschutz: "",
      impressum: "",
      color: "",
      sprache: "",
      signature: "",
      hello: ""
    },
    logo: null,
    logoo: null,
    logooo: null,
    logo_placeholder: require('../../assets/images/camera-icon.svg'),
  }),
  created() {
    
  },
  async mounted() {
    if(this.options.currentRoute != 'Brandings'){
      this.options.showBrandForm = false;
    }
    let self = this;
    await self.doPost({}, 'getglobalinfo', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data[0];
        
        self.logoNew = result.baseLogo;
        self.logooo = process.env.VUE_APP_CRM_URL+"/titleImgs/favicon."+result.favicon;

        if (result.logoback) {
          self.logoback = process.env.VUE_APP_CRM_URL + "/titleImgs/file." + result.logoback;
        } else {
          console.error("Error: result.logoback is null or undefined");
        }
        self.emailBetreffCustomer_de = result.emailBetreffSupplier_de;
        self.stornoStatus = result.stornoStatus;
        self.address.defaultcount = result.defaultCount;
        self.emailBetreffCustomer_en = result.emailBetreffSupplier_en;
        self.editor6.commands.setContent(self.emailBetreffCustomer_de);
        self.editor7.commands.setContent(self.emailBetreffCustomer_en);

        self.emailBetreffSupplier_de = result.emailBetreffSupplier_de
        self.emailBetreffSupplier_en = result.emailBetreffSupplier_en
      }
    });
    await self.getModules();
    await self.getDefaultBrand();

  },
  beforeDestroy(){
    // ensure body scroll restored if modal was open
    if (typeof document !== 'undefined') {
      document.body.classList.remove('modal-open')
    }
  },
  watch: {
    clear() {
    }
  },
  methods: {
    async changeStorno(){
      let data = {
			  status : this.stornoStatus,
        todo: "storno"
		  }
      let self = this;
      await self.doPost({data: data}, 'updateglobalinfo', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
      }
    });
    },
    async resetpdfs(){
      let data = {
			  tripId : "allall"
		}
      let self = this;
      await self.doPost({data: data}, 'setStatusPdf', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        self.pdfReset = false;
        self.options.showSuccess = true;
      }
    });
    },
    selectDefaultBrand(){
    },
    async setDefaultBrand(){
      let myData = {
        id: this.defaultbrand
      }
      let self = this;
      await self.doPost({data: myData}, 'setDefaultBrand', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        self.options.showSuccess = true;
      }
    });
      await this.getDefaultBrand();
    },
    async setDefaultCount(){
      let myData = {
        id: this.address.defaultcount
      }
      let check = Number(myData.id)
      if(Number.isInteger(check)){
        let self = this;
        
        await self.doPost({data: myData}, 'setDefaultCount', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            self.options.showSuccess = true;
          }
        });
        
        await this.getDefaultBrand();
      }else{
        this.showErrorMsg(this.options.Lang.getNumber)
      }
      
    },
    async getDefaultBrand(){
      let self = this;
      await self.doPost({}, 'getglobalinfo', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data[0];
        self.defaultbrand = result.normalBrand;
      }
    });
    },
    getModules(){
      this.renderComp = false;
      let self = this;
      self.brands = []
    self.doPost({}, 'getAllBranding', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data;
        for(let i = 0; i < result.length; i++){
          self.brands.push(result[i])
        
        }
        self.renderComp = true;

      }
    });
    },
    async saveVorlagen(){
      let newValues = {
        newEmailDe: this.editor.getHTML(),
        newEmailEn: this.editor2.getHTML()
      }
      let self = this;
      await this.doPost({data: newValues}, 'setdbmails', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.options.showSuccess = true;
        }
      });
    },
    abort() {
      location.reload();
    },
    close(){
      this.options.showGlobalInfoForm = false;
    },
    getImg(event) {
      this.logo = event.target.files[0]; 
      const reader = new FileReader();
      reader.onload = (e) => {
        this.logo = e.target.result; 
      };
      reader.readAsDataURL(this.logo);
      this.logoReader = reader
    },
    getImgback(event) {
      this.logoo = event.target.files[0]; 
      const reader = new FileReader();
      reader.onload = (e) => {
        this.logoo = e.target.result; 
      };
      reader.readAsDataURL(this.logoo);
      this.logoBackReader = reader
    },
    getFavicon(event) {
      this.logooo = event.target.files[0]; 
      const reader = new FileReader();
      reader.onload = (e) => {
        this.logooo = e.target.result; 
      };
      reader.readAsDataURL(this.logooo);
      this.logoFavReader = reader
    },
    async saveImg() {
      let self = this;
      
      async function Main(blub) {
        let baseFile = self.logoReader.result
        let myData={
          baseFile: baseFile,
        }
        await self.doPost({ data: myData }, 'uploadLogo', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            self.options.showSuccess = true;
          }
        });
       
      }
      await Main(this.logo);
      self.options.showSuccess = true;
    },
    async saveImgback() {
      let self = this;
      
      async function Main(blub) {
        let baseFile = self.logoBackReader.result
        let myData={
          baseFile: baseFile,
        }
        await self.doPost({ data: myData }, 'uploadLogoback', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            self.options.showSuccess = true;
          }
        });
       
      }
      await Main(this.logo);
      self.options.showSuccess = true;
    },
    async saveFavicon() {
      let self = this;
      
      async function Main(blub) {
        let baseFile = self.logoFavReader.result
        let myData={
          baseFile: baseFile,
        }
        await self.doPost({ data: myData }, 'uploadFavicon', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            self.options.showSuccess = true;
          }
        });
       
      }
      await Main(this.logo);
      self.options.showSuccess = true;
    },
    openDialog() {
    },
    closeDialog() {
      this.options.showGlobalInfoForm = false;
    },
    refreshDialog() {
      let self = this;
      self.options.showGlobalInfoForm = false;
   
    }
  }
}
</script>
<style>
.fileField{
  width: 17.8rem !important;
}

.formi{
  margin-right: 3rem;
}

::-webkit-scrollbar {
    display: none;
}

#pdfReset{
  position: relative;
  height: 13rem;
  width: 40%;
  left: 25%;
  background-color: white;
  padding: 2rem;
  top: -40rem;
}

body.modal-open{
  overflow: hidden !important;
}

#emailvorlage{
  margin-left: 3rem;
  margin-right: 3rem;
  margin-top: 2rem;
}
.editCat{
  z-index: 111111;
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: transparent;
}
.bgEdit{
  background-color: rgb(94, 94, 94);
  padding-top: 1rem;
  padding-bottom: 1rem;
  height: 100%;
  width: 100%;
  opacity: 0.5;
}

#divEmail{
  background: white;
  width: 107%;
  padding: 3rem;
  margin-left: -3rem;
  padding-bottom: 5rem;
}

.areaa{
  padding: 10px 10px !important;
  background-color: #F5F6FA !important;
  line-height: 20px;
  height: 52px;
  font-size: 14px !important;
  color: #202224 !important;
  border: 0.6px solid #D5D5D5;
  -webkit-text-fill-color: #A6A6A6 !important;
  border-radius: 4px;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  max-width: 100% !important;
  min-width: 100% !important;
  font-family: inherit;
}


.contentEdit{
  margin-top: -14rem;
  padding: 3rem;
  background-color: white;
  width: 90%;
  height: 80%;
  left: 5%;
}
.formTD {
  background-color: rgb(249, 249, 249);
  margin-bottom: 5px;
}

.choose-file::file-selector-button {
  font-weight: bold;
  color: #202224;
  font-family: "Nunito", sans-serif !important;
  font-size: 14px !important;
  background-color: #E1E8F3;
  padding: 10px 24px;
  outline: none;
  border: none;
  border-radius: 10px;
  width: 155px;
  height: 38px;
  display: inline-block;
  margin-top: 8px;
}

.choose-file::file-selector-button:hover{
 cursor:pointer;
 background-color: #c9cbce;
}

#sigfield{
  z-index: 111111;
}

#logo{
  width: 100% !important;
}

#logoback{
  width: 100% !important;
}

.secondary,
.button-save {
  height: 38px !important;
}

.imglogoback{
  max-width: 100% !important;
  max-height: 100% !important;
}

.uploadedLogo{
  display: flex;
  justify-content: center;
  align-items: center;
  background: #E1E8F3;
  height: 260px;
  width: 284px;
  margin-top: 10px;
  margin-bottom: 10px;
}


.blubbiblubbi.haii .ProseMirror{
  min-height: 3rem !important;
  max-height: 3rem !important;
  min-width: 44rem !important;
  max-width: 44rem !important;
}

#street,#plz,#company,#tel,#fax,#city,#email,#impressum,#datenschutz,#color,#signature, #hello, #reply, #replyzugang, #agbs, #footerinfo, #defaultcount, #emailBetreffSupplier_de, #emailBetreffSupplier_en{
  -webkit-text-fill-color: black !important;
}



</style>
